<template>
<div>
  <div class="side" :class="[sidebarState ? 'side-bar-open' : '']">
    <div class="side-overlay" @click="toggleSidebar(false)">
      <div class="side-bar-closer">
        <i class="mdi mdi-close"></i>
      </div>
    </div>

    <div class="side-wrapper">
      
      <div class="side-content">
        <div class="text-center unmenu">
          <router-link :to="{name : 'Profile'}" class="profile-wrapper">
            <div v-if="userData.user_detail" class="profile-img">
              <img v-if="userData.user_detail.profile_picture" :src="this.ImageUrl+userData.user_detail.profile_picture">
              <img v-else :src="this.StaticImageUrl+'assets/images/empty-user.png'">

            </div>
              <span class="status-badge">
                <i class="mdi mdi-account-cog"></i>
              </span>
          </router-link>

          <!-- <div class="user-name">
            <template v-if="userData.fullname">
              <h5>{{ userData.fullname }}</h5>
            </template>
          </div> -->
          
          <div class="user-stars">
            <template v-if="userData.user_detail">
              <i class="mdi" :class="[ userData.user_detail.stars >= 5 ? 'mdi-star active' : 'mdi-star-outline' ]"></i>
              <i class="mdi" :class="[ userData.user_detail.stars >= 4 ? 'mdi-star active' : 'mdi-star-outline' ]"></i>
              <i class="mdi" :class="[ userData.user_detail.stars >= 3 ? 'mdi-star active' : 'mdi-star-outline' ]"></i>
              <i class="mdi" :class="[ userData.user_detail.stars >= 2 ? 'mdi-star active' : 'mdi-star-outline' ]"></i>
              <i class="mdi" :class="[ userData.user_detail.stars >= 1 ? 'mdi-star active' : 'mdi-star-outline' ]"></i>
            </template>
          </div>

          <span class="ar-btn size-sm outline-light round">
            <template v-if="userData.user_detail.user_status == 0">
              احراز نشده
            </template>
            <template v-if="userData.user_detail.user_status == 1">
              در حال بررسی <img style="height:26px" :src="this.StaticImageUrl+'assets/images/site-icons/data_pending.svg'">
            </template>
            <template v-else-if="userData.user_detail.user_status == 2">
              احراز شده <img style="height:26px" :src="this.StaticImageUrl+'assets/images/site-icons/verified_account.svg'">
            </template>
            <template v-else-if="userData.user_detail.user_status == 3">
              رد شده <img style="height:26px" :src="this.StaticImageUrl+'assets/images/site-icons/cancel.svg'">
            </template>
          </span>
        </div>
        
        <ul class="side-list profile">
          
          <li class="has-menu">
            <div class="titr">
              <div class="inner-menu">
                <span class="icon"><i class="mdi mdi-account-edit"></i></span>
                <router-link :to="{name : 'Profile'}">پروفایل</router-link>
              </div>
              <span class="arrow"></span>
            </div>
          </li>

        </ul>

        <ul class="side-list main">
          
          <li class="has-menu" :class="[active_menus.includes('my_account') ? 'active' : '']">
            <div @click="toggleSubMenu('my_account')" class="titr">
              <div class="inner-menu">
                <span class="icon"><i class="mdi mdi-account-outline"></i></span>
                <a>حساب من</a>
              </div>
              <span class="arrow"><i class="mdi mdi-chevron-left"></i></span>
            </div>
            <ul>
              <li>
                <router-link :to="{name:'Dashboard'}">سبد دارایی</router-link>
              </li>
              <li>
                <router-link :to="{name:'BankAccounts'}">حساب های بانکی</router-link>
              </li>
              <li>
                <router-link :to="{name:'Wallets'}">ولت ها</router-link>
              </li>
              <li>
                <router-link :to="{name:'Security'}">امنیت</router-link>
              </li>
              <li>
                <router-link :to="{name:'Referral'}">معرفی به دوستان</router-link>
              </li>
            </ul>
          </li>
          
          <li class="has-menu" :class="[active_menus.includes('exchanges') ? 'active' : '']">
            <div @click="toggleSubMenu('exchanges')" class="titr">
              <div class="inner-menu">
                <span class="icon"><i class="mdi mdi-arrow-up-down-bold-outline"></i></span>
                <a>مبادلات (otc)</a>
              </div>
              <span class="arrow"><i class="mdi mdi-chevron-left"></i></span>
            </div>
            <ul>
              <li>
                <router-link :to="{name:'Transaction'}">خرید و فروش فوری</router-link>
              </li>
              <li>
                <router-link :to="{name:'ConvertCrypto'}">تبدیل کریپتو به تتر/تومان</router-link>
              </li>
              <li>
                <router-link :to="{name:'Records'}">تاریخچه مبادلات</router-link>
              </li>
            </ul>
          </li>
          
          <li class="deactive" :class="[active_menus.includes('markets') ? 'active' : '']">
            <div class="titr">
              <div class="inner-menu">
                <span class="icon"><i class="mdi mdi-poll"></i></span>
                <a>بازار تتر</a>
              </div>
              <span class="arrow"></span>
            </div>
          </li>
          <!-- <li :class="[active_menus.includes('markets') ? 'active' : '']">
            <div class="titr">
              <div class="inner-menu">
                <span class="icon"><i class="mdi mdi-poll"></i></span>
                <router-link :to="{name:'Market'}">بازار تتر</router-link>
              </div>
              <span class="arrow"></span>
            </div>
          </li> -->
          
          <li v-if="userData.user_detail" class="has-menu" :class="[ { 'active': active_menus.includes('arzine_club'), 'deactive': parseInt(userData.user_detail.stars) < 3 } ]">
            <div @click="toggleSubMenu('arzine_club')" class="titr">
              <div class="inner-menu">
                <span class="icon"><i class="mdi mdi-currency-usd"></i></span>
                <a>ارزینه کلاب</a>  
              </div>
              <span class="arrow"><i class="mdi mdi-chevron-left"></i></span>
            </div>
            <ul>
              <li>
                <a>تسهیلات</a>
              </li>
              <li>
                <a>ارزینه کارت</a>
              </li>
            </ul>
          </li>

        </ul>

      </div>
        
      <div class="logout-container">
        <logout-btn>
          <ul class="side-list p-0 m-0">
            <li>
              <div class="titr">
                <div class="inner-menu">
                  <span class="icon"><i class="mdi mdi-logout"></i></span>
                  <a>خروج از حساب کاربری</a>
                </div>
                <span class="arrow"></span>
              </div>
            </li>
          </ul>
        </logout-btn>
      </div>

    </div>

  </div>

  <div class="bottom-side">
    <div class="bottom-side-inner">

      <router-link :to="{name:'MyAccount'}" class="bottom-side-item"
        :class="[active_nav === 'my_account' ? 'active' : '']"
      >
        <div class="icon"><i class="mdi mdi-account-outline"></i></div>
        <div class="titr">حساب من</div>
      </router-link>

      <router-link :to="{name:'Exchanges'}" class="bottom-side-item"
        :class="[active_nav === 'exchanges' ? 'active' : '']"
      >
        <div class="icon"><i class="mdi mdi-arrow-up-down-bold-outline"></i></div>
        <div class="titr">مبادلات</div>
      </router-link>

      <!-- <router-link :to="{name:'Market'}" class="bottom-side-item"
        :class="[active_nav === 'markets' ? 'active' : '']"
      >
        <div class="icon"><i class="mdi mdi-poll"></i></div>
        <div class="titr">بازار تتر</div>
      </router-link> -->

      <a class="bottom-side-item disabled"
        :class="[active_nav === 'markets' ? 'active' : '']"
      >
        <div class="icon"><i class="mdi mdi-poll"></i></div>
        <div class="titr">بازار تتر</div>
      </a>

      <a class="bottom-side-item disabled">
        <div class="icon"><i class="mdi mdi-currency-usd"></i></div>
        <div class="titr">ارزینه کلاب</div>
      </a>

    </div>
  </div>
</div>
</template>
<script>
import LogoutBtn from '../../../components/LogoutBtn'
export default {
  name: 'Sidebar',
  components:{
    LogoutBtn ,
  },
  data : () => ({
    opened : null,
    active_nav : null,
    active_menus:[]
  }),
  watch:{
    $route (to, from){
      this.toggleSidebar(false)
    }
  },
  methods:{
    toggle_menu(item){
      if(this.opened == item){
        this.opened = null
      }else{
        this.opened = item
      }
    },
    toggleSubMenu(item){
      if(item === 'arzine_club' && this.userData.user_detail.stars < 3) return
      if(this.active_menus.includes(item))
      {
        const index = this.active_menus.indexOf(item);
        if (index > -1) {
          this.active_menus.splice(index, 1);
        }
      }else{
        this.active_menus.push(item)
      }
    }
  },
  mounted() {

    const route = this.$route.name;
    const my_accounts = ['MyAccount','Dashboard','BankAccounts','Wallets','Security','Referral','Deposit','Withdraw'];
    const exchanges = ['Exchanges','Transaction','ConvertCrypto','Records'];
    const markets = ['Market'];
    if(my_accounts.includes(route))
    {
      this.toggleSubMenu('my_account')
      this.active_nav = 'my_account'
    }else if(exchanges.includes(route)){
      this.toggleSubMenu('exchanges')
      this.active_nav = 'exchanges'
    }else if(markets.includes(route)){
      this.toggleSubMenu('markets')
      this.active_nav = 'markets'
    }

  }
}
</script>
<style>

</style>